module.exports = __webpack_public_path__ + "static/media/SVG_building.6549ac03.svg";